import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoRow=({curso, onShowModalBorrar, onShowModalActivar,onShowModalDuplicar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{curso.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{curso.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/cursocat/"+curso.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(curso.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={curso.idEstatus==1?'x':'check'} link  size="large" 
                                                color={curso.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(curso.id)} 
                                            />
                                        }
                                        content={curso.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='clone' link 
                                            onClick={()=>onShowModalDuplicar(curso.id)} 
                                            size="large" color="green"  />
                                        }
                                        content='Duplicar'
                                      />
                                </List.Item>          
                            </List>
                        </Table.Cell>
                        <Table.Cell textAlign="center">    
                            <List>          
                            <List.Item>
                                    <Link to={"/cursoTest/"+curso.id}> 
                                     <Popup
                                        trigger={<Icon  name='eye' link   size="large"  color="tela" ></Icon>}
                                        content='Visualizar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>          
                            </List>
                        </Table.Cell>              
        </Table.Row>
    
    )
}

//cursoTest


export default CursoRow;